import routeSaga from './sagas/RouteSaga';
import routeStopSaga from './sagas/RouteStopSaga';
import driverSettingSaga from './sagas/DriverSettingSaga';
import driverSettingTypeSaga from './sagas/DriverSettingTypeSaga';

export default [routeSaga, routeStopSaga, driverSettingSaga, driverSettingTypeSaga];
